
const NoSurveyMessage="نظرسنجی فعالی وجود ندارد";
const ssnError="کد ملی صحیح نیست";
const Recorder=["صفر","اول","دوم","سوم","چهارم","پنجم","ششم","هفتم","هشتم","نهم","دهم","یازدهم","دوازدهم","سیزدهم",
    "چهاردهم","پانزدهم","شانزدهم","هفدهم","هجدهم","نوزدهم","بیستم"]
    const ageGroup = [

  {
    id: "1",
    label: "بالاي 12 سال"
  },
  {
    id: "2",
    label: "7 تا 12 سال"
  },
  {
    id: "3",
    label: "2 تا 7 سال"
  },
  {
    id: "4",
    label: "زیر دو سال"
  },
]
const staticData={ssnError,NoSurveyMessage,Recorder,ageGroup}
export default staticData;